module.exports = __webpack_public_path__ + "static/media/default.b4e33a6b.png";